export default "__VITE_ASSET__b9afaa98__"